<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs
      v-model="tab.tabIndex"
      class="mb-4"
      @activate-tab="changeDisplayTypeTabs"
    >
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <div class="d-flex mb-4">
      <b-form-select class="mr-sm-2 mb-sm-0 w-25" v-model="search.rank" :options="options.rank">
        <template #first>
          <b-form-select-option :value="null" disabled>-- 聘階 --</b-form-select-option>
          <b-form-select-option value="">全部</b-form-select-option>
        </template>
      </b-form-select>

      <!-- <b-form-input
        class="mr-sm-2 mb-sm-0 w-25"
        placeholder="聘階"
        v-model="search.rank"
        @keyup.enter="getSalesTree(tab.tabIndex)" /> -->

      <b-button variant="primary" @click="getSalesTree(tab.tabIndex)">查詢</b-button>
    </div>

    <b-form-checkbox
      v-if="tab.tabIndex !== 2"
      class="mb-4"
      switch
      size="lg"
      v-model="status.allToggleExpand"
    >
      全部階層開關
    </b-form-checkbox>

    <ul v-if="tab.tabIndex === 0" id="root">
      <tree-list
        :tree="tree"
        @on-mouseover="onMouseover"
        @on-mouseout="onMouseout"
        @on-click="nodeClick"
      ></tree-list>
    </ul>

    <vue2-org-tree
      v-else-if="tab.tabIndex === 1"
      :data="tree"
      :horizontal="true"
      collapsable
      @on-expand="onExpand"
      @on-node-click="nodeClick"
      @on-node-mouseover="onMouseover"
      @on-node-mouseout="onMouseout" />

    <tables-page
      v-else-if="tab.tabIndex === 2"
      :tableData="table_data"
      :tableFields="table_fields"
    >
      <template #cell(generations)="row">
        第{{ row.item.generations }}代
      </template>

      <template #cell(latest_reports)="row">
        {{ convertRocDate(row.item.new_member_join_date) }} {{ row.item.new_member_number }} {{ row.item.new_member_name }}
      </template>

      <template #cell(valid_count)="row">
        <span v-if="row.item.valid_count > 0" class="link" @click="openContractModal(null, row.item)">
          {{ row.item.valid_count }}
        </span>
        <span v-else>
          {{ row.item.valid_count }}
        </span>
      </template>

      <template #cell(function)="row">
        <b-button
          v-if="row.item.unpay !== 0"
          variant="info"
          size="sm"
          @click="nodeClick($event, row.item)"
        >
          直推會員繳款明細表
        </b-button>
      </template>
    </tables-page>

    <div v-show="status.hoverInfoSwich" class="floating" ref="floating">
      <div>最新報件：{{ convertRocDate(data.hoverInfo.new_member_join_date) }} {{ data.hoverInfo.new_member_number }} {{ data.hoverInfo.new_member_name }}</div>
      <div v-if="status.hoverType === 'contract'" class="text-warning">(點擊，即可查看-相關契約)</div>
      <div v-else-if="data.hoverInfo.unpay > 0" class="text-warning">(點擊，即可查看-直推會員繳款明細表)</div>
    </div>

    <!-- 直推會員繳款明細表 modal -->
    <member-payment-modal
      v-model="status.memberUnpaidModal"
      :data="data.temp_table_data" />

    <organization-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import businessInfoApi from "@/models/API/businessInfoApi";
import { convertRocDate, getLocalUserInfo } from "@/models/HELPERS/common.js";
import MemberPaymentModal from './components/modal/MemberPaymentModal.vue';
import OrganizationContractModal from './components/modal/OrganizationContractModal.vue';
import TreeList from './components/common/TreeList.vue';
import TablesPage from "@/components/layouts/TablesPage";

export default {
  name: 'organizationTree',
  components: {
    BreadCrumb,
    MemberPaymentModal,
    OrganizationContractModal,
    TreeList,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '圖表', url: '', isActive: true },
          { name: '組織樹', url: '', isActive: false }
        ]
      },
      options: {
        rank: [
          { value: '總監', text: '總監' },
          { value: '經理', text: '經理' },
          { value: '業務', text: '業務' },
          { value: '儲備總監', text: '儲備總監' },
          { value: '主任', text: '主任' }
        ],
      },
      status: {
        hoverInfoSwich: false,
        hoverType: 'default',
        memberUnpaidModal: false,
        contractModal: false,
        allToggleExpand: true
      },
      search: {
        rank: null
      },
      tab: {
        items: [
          {
            label: '列表型組織',
            value: 0
          },
          {
            label: '樹狀型組織',
            value: 1
          },
          {
            label: '表格型組織',
            value: 2
          },
        ],
        tabIndex: 0
      },
      data: {
        info: {},
        hoverInfo:{
          new_member_join_date: '',
          new_member_number: '',
          new_member_name: '',
          unpay: ''
        },
        temp_table_data: {}
      },
      tree: {},
      // tree: {
      //   id: 0,
      //   label: "XXX科技有限公司",
      //   children: [
      //     {
      //       id: 2,
      //       label: "产品研发部",
      //       children: [
      //         {
      //           id: 5,
      //           label: "研发-前端"
      //         },
      //         {
      //           id: 6,
      //           label: "研发-后端"
      //         },
      //         {
      //           id: 9,
      //           label: "UI设计"
      //         },
      //         {
      //           id: 10,
      //           label: "产品经理"
      //         }
      //       ]
      //     },
      //     {
      //       id: 3,
      //       label: "销售部",
      //       children: [
      //         {
      //           id: 7,
      //           label: "销售一部"
      //         },
      //         {
      //           id: 8,
      //           label: "销售二部"
      //         }
      //       ]
      //     },
      //     {
      //       id: 4,
      //       label: "财务部"
      //     },
      //     {
      //       id: 9,
      //       label: "HR人事"
      //     }
      //   ]
      // },
      treeData: {
        name: 'Root',
        node: [
          { name: 'Level1'},
          {
            name: 'Level2',
            node: [
              { name: 'Level3'}
            ]
          }
        ]
      },
      table_fields: [
        {
          key: "generations",
          label: "代數",
        },
        {
          key: "number",
          label: "編號",
        },
        {
          key: "name",
          label: "姓名",
        },
        {
          key: "rank",
          label: "聘階",
        },
        {
          key: "latest_reports",
          label: "最新報件",
        },
        {
          key: "sales_count",
          label: "業務",
        },
        {
          key: "valid_count",
          label: "直推"
        },
        {
          key: "unpay",
          label: "直推未繳"
        },
        {
          key: "function",
          label: "功能"
        }
      ],
      table_data: [],
    }
  },
  watch: {
    'status.allToggleExpand': {
      handler(newValue, oldValue) {
        this.toggleExpand(this.tree, newValue);
      },
      immediate: false
    }
  },
  created() {
    this.$root.$on('on-mouseover', this.onMouseover);
    this.$root.$on('on-mouseout', this.onMouseout);
    this.$root.$on('on-click', this.nodeClick);
    this.$root.$on('on-valid-count-click', this.openContractModal);
  },
  mounted() {
    this.businessInfoApi = new businessInfoApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
      this.getSalesTree();
    },
    convertRocDate,
    // 改變顯示方式tab 時觸發
    changeDisplayTypeTabs(newTabIndex, prevTabIndex, bvEvent) {
      if (newTabIndex === 2) {
        this.getSalesTree(newTabIndex);
      } else {
        if (prevTabIndex === 2) this.getSalesTree(newTabIndex);
      }
    },
    // 查詢業務樹狀圖
    getSalesTree(displayType_tabIndex = 0) {
      const params = {
        'ID_number': this.data.info.account,
        ...this.search,
         'flat': displayType_tabIndex === 2 ? 1 : 0
      };
      this.businessInfoApi.getSalesTree((response) => {
        const res = response.data;

        if (res.data.length > 0) {
          if (displayType_tabIndex === 2) {
            this.table_data = res.data;
          } else {
            this.tree = res.data[0];

            this.addLabelToTree(this.tree);
          }
        }

      }, params)
    },
    addLabelToTree(tree) {
      const startTime = performance.now();
      const queue = [tree];

      while (queue.length > 0) {
        const node = queue.shift();
        const is_new_member = node.new_member_join_date && node.new_member_number && node.new_member_name ? true : false;
        
        const genLabel = (validCountText) => `第${node.generations}代-${node.number}(${node.name}：${node.rank})
          ${is_new_member ? `　最新報件：${convertRocDate(node.new_member_join_date)} ${node.new_member_number} ${node.new_member_name}` : ''}
          　業務：${node.sales_count} 直推：${validCountText}
          　直推未繳：${node.unpay}`;

        node.label = genLabel(node.valid_count);
        node.htmlLabel = genLabel(node.valid_count > 0 ? `<span class="link valid-count-target">${node.valid_count}</span>` : node.valid_count);

        if (node.children && node.children.length > 0) {
          for (let i = 0; i < node.children.length; i++) {
            const child = node.children[i];
            const is_new_member_child = child.new_member_join_date && child.new_member_number && child.new_member_name ? true : false;

            const genChildLabel = (validCountText) => `第${child.generations}代-${child.number}(${child.name}：${child.rank})
              ${is_new_member_child ? `　最新報件：${convertRocDate(child.new_member_join_date)} ${child.new_member_number} ${child.new_member_name}` : ''}
              　業務：${child.sales_count} 直推：${validCountText}
              　直推未繳：${child.unpay}`;

            child.label = genChildLabel(child.valid_count);
            child.htmlLabel = genChildLabel(child.valid_count > 0 ? `<span class="link valid-count-target">${child.valid_count}</span>` : child.valid_count);
            
            queue.push(child);
          }
        }
      }

      const endTime = performance.now();
      const executionTimeMs = endTime - startTime;
      const executionTimeSec = executionTimeMs / 1000;
      console.log("addLabelToTree 執行時間：", executionTimeSec, "秒");
      console.log( this.tree);

      this.toggleExpand(this.tree, true);
    },
    // 樹狀圖全部展開
    toggleExpand(data, val) {
      const _this = this;

      if (Array.isArray(data)) {
          data.forEach(function(item) {
            _this.$set(item, "expand", val);
            if (item.children) {
              _this.toggleExpand(item.children, val);
            }
          });
      } else {
          this.$set(data, "expand", val);
          if (data.children) {
            _this.toggleExpand(data.children, val);
          }
      }
    },
    collapse(list) {
      const _this = this;

      list.forEach(function(child) {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
            this.collapse(data.children);
        }
      } else {
          this.$set(data, "expand", true);
      }
    },
    // 點擊樹狀圖
    nodeClick(e, data) {
      if (data.unpay === 0) return;

      this.data.temp_table_data = Object.assign({}, data);

      this.status.memberUnpaidModal = true;
    },
    openContractModal(e, data) {
      let nodeData = data || e;
      this.data.temp_table_data = Object.assign({}, nodeData);
      this.status.contractModal = true;
    },
    // 滑鼠移出
    onMouseout(e, data) {
      this.status.hoverInfoSwich = false;
    },
    // 滑鼠移入
    onMouseover(e, data, hoverType = 'default') {
      this.data.hoverInfo = data;
      this.status.hoverType = hoverType;
      this.status.hoverInfoSwich = true;

      const floating =  this.$refs.floating;

      if (floating) {
        floating.style.left = e.pageX +'px';
        floating.style.top = e.pageY+'px';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.floating{
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  box-sizing: border-box;
  left: 0;
  top: 0;
  transition: all 0.3s;
  z-index: 999;
  text-align: left;
  font-size: 16px;
}
/deep/ .org-tree-node-label .org-tree-node-label-inner {
  width: 15rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/businessInfo/organizationTree.vue